// Module
var code = "<nav3-menu> <nav3-menu-col> <nav3-menu-item id=\"catalog-nav-dropdown-item\" state=\"catalog\" text=\"Product Catalog\"></nav3-menu-item> </nav3-menu-col> </nav3-menu> ";
// Exports
module.exports = code;